import React, { useEffect, useState } from 'react';
import { RecepcionesFletesApi } from '../../../../../Utils/APIs/bonificacionesApi/RecepcionesFletesApi';
import TotalesBonificacion from '../../../../../Utils/Components/TotalesBonificacion';
import TablaBonifFletes from '../../../../../Utils/Components/RecepcionesBonificacion/TablaBonifFletes';
import '../RecepcionesBonificacion.css';

/**
 * Componente que muestra las recepciones de fletes y sus bonificaciones.
 * @param {Object} props - Props del componente.
 * @param {number} props.orden_compra_id - ID de la orden de compra.
 * @param {function} props.setTotalesFletes - Función para establecer los totales de fletes.
 * @returns {JSX.Element} - Componente de recepciones de fletes.
 */
const RecepcionesFletes = (props) => {
    const { orden_compra_id, setTotalesFletes, setRecepcionesFletes } = props;
    const { getRecepcionesFletes, getTotalesFletes } = RecepcionesFletesApi();
    const [recepciones, setRecepciones] = useState([]);

    // TOTALES
    const [totalesBonificacion, setTotalesBonificacion] = useState({
        total_bonificaciones: 0,
        total_kg: 0,
        total_bonos: 0,
        total_bonos_quetzales: 0,
    });

    const getData = async () => {
        const recepcionesFletes = await getRecepcionesFletes({ orden_compra_id });
        const totales = await getTotalesFletes({ orden_compra_id });
        setRecepciones(recepcionesFletes.results || []);
        if (setRecepcionesFletes) setRecepcionesFletes(recepcionesFletes.results || []);
        setTotalesBonificacion(totales || {});
        if (setTotalesFletes) setTotalesFletes(totales);
    }

    useEffect(() => {
        if (!!orden_compra_id) {
            getData();
        }
    }, [orden_compra_id]);

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='mx-3 my-2 mb-4'>
                    <div className="recepciones-bonificacion-ver">
                        {/* Solo mostrar si hay recepciones */}
                        {recepciones && recepciones.length > 0 && (
                            <div>
                                <h4 className='mb-2 text-center'>Bonificación por Transporte</h4>
                                <div className='new-table-wrapper liquidaciones-crear__table-wrapper'>
                                    <TablaBonifFletes recepciones={recepciones} />
                                </div>
                                <TotalesBonificacion
                                    totalesBonificacion={totalesBonificacion}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default RecepcionesFletes;
